export const REGEX_PATTERN = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // Minimum eight characters, at least one uppercase letter, one lowercase letter and one number:
  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[.,:;~`@#$^()_[|\]\\<>'"/{}!%*?&=+-])[A-Za-z\d?=.*[!@#$%^&*,.()_\-+=`~{};[\]:/">'<|\\€]{8,}$/,
  phone: /^\+(?!0)\d{3,13}$/,
};
